/**
 * @generated SignedSource<<a1292e7802621f9d30f3c67f4c36aee7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastSpaceWidget_subWidget$data = {
  readonly __typename: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFile_widgetFile" | "WidgetNote_widgetNote">;
  readonly " $fragmentType": "StorecastSpaceWidget_subWidget";
};
export type StorecastSpaceWidget_subWidget$key = {
  readonly " $data"?: StorecastSpaceWidget_subWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastSpaceWidget_subWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastSpaceWidget_subWidget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNote_widgetNote"
        }
      ],
      "type": "WidgetNote",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetFile_widgetFile"
        }
      ],
      "type": "WidgetFile",
      "abstractKey": null
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};

(node as any).hash = "5a29b557f5f162770b81725eb4ef0fc9";

export default node;
